// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});




export function plus_click(event) {
	//Add your code for this event here: 

	$w('#1').show()
	$w('#2').show()
	$w('#3').show()
	$w('#4').show()
	$w('#5').show()
	$w('#6').show()

	$w('#plus').hide()
	$w('#minus').show() 
}



export function minus_click(event) {
	//Add your code for this event here:

$w('#1').hide()
$w('#2').hide()
$w('#3').hide()
$w('#4').hide()
$w('#5').hide()
$w('#6').hide()
$w('#minus').hide()
$w('#plus').show()
		

}